module.exports = __webpack_public_path__ + "img/eqip3.20b60ecb.png";